import { __rest } from '../../../_virtual/_tslib.js';
import React__default from 'react';
import { getId } from '../../../utils/index.js';
import { Button } from '../../Button/index.js';

function ModalActions(_a) {
    var { primaryAction, dismissAction, variant, stackedActionButtons } = _a, props = __rest(_a, ["primaryAction", "dismissAction", "variant", "stackedActionButtons"]);
    const appendTestId = getId(props['data-testid']);
    const appendTrackId = getId(props['data-trackid']);
    return (React__default.createElement(React__default.Fragment, null,
        dismissAction && (React__default.createElement(Button, Object.assign({ role: "button", variant: "ghost", fullWidth: stackedActionButtons }, dismissAction, { size: variant === 'narrow' ? 'small-expressive' : 'large', "data-testid": appendTestId('action-dismiss'), "data-trackid": appendTrackId('action-dismiss') }), dismissAction.text)),
        React__default.createElement(Button, Object.assign({ role: "button", fullWidth: stackedActionButtons }, primaryAction, { size: variant === 'narrow' ? 'small-expressive' : 'large', "data-testid": appendTestId('action-primary'), "data-trackid": appendTrackId('action-primary') }), primaryAction.text)));
}

export { ModalActions };
